import navBarHomepage from '../modules/navbar-homepage';
import postShareButtons from '../modules/post-share-buttons';

let companyController = () => {
    require('../modules/slideshow/create_mic_slideshow')();
    navBarHomepage.on();
    postShareButtons.on();
};

export default companyController;
